import { render, staticRenderFns } from "./GoodsInfoAdmin.vue?vue&type=template&id=68cc6e40&scoped=true"
import script from "./GoodsInfoAdmin.vue?vue&type=script&lang=js"
export * from "./GoodsInfoAdmin.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfoAdmin.vue?vue&type=style&index=0&id=68cc6e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cc6e40",
  null
  
)

export default component.exports